import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { useTheme } from "@material-ui/core/styles";

import { toast } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Pagination from "@material-ui/lab/Pagination";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import { Box } from "@mui/material";
import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactListItemModal from "../../components/ContactListItemModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import ImportProgressModal from "../../components/ImportProgressModal";
import ImportReportModal from "../../components/ImportReportModal";

import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import useContactLists from "../../hooks/useContactLists";
import { useValidationProgress } from "../../context/ValidationProgress/ValidationProgressContext";
import { Grid } from "@material-ui/core";

import planilhaExemplo from "../../assets/planilha.xlsx";
import ForbiddenPage from "../../components/ForbiddenPage";

import * as XLSX from "xlsx";



const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  invalidContactsIndicator: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
    cursor: "pointer",
    padding: theme.spacing(0.5, 1),
    border: "1px solid #f44336",
    borderRadius: theme.spacing(0.5),
    backgroundColor: "#ffebee",
    boxShadow: "0 2px 4px rgba(244, 67, 54, 0.2)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      boxShadow: "0 4px 8px rgba(244, 67, 54, 0.3)",
      transform: "translateY(-1px)",
    },
  },
  invalidContactsCount: {
    fontWeight: "bold",
    color: "#d32f2f",
    fontSize: "14px",
    minWidth: "16px",
    textAlign: "center",
  },
  invalidContactsText: {
    color: "#d32f2f",
    fontSize: "12px",
    fontWeight: "500",
  },
  statusBox: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
  validationIndicator: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  validationProgress: {
    color: theme.palette.primary.main,
  },
  validationText: {
    fontSize: "12px",
    color: theme.palette.primary.main,
    fontWeight: "500",
  },
  // Estilos responsivos para botões superiores
  topButtonsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    alignItems: "center",
    [theme.breakpoints.up('lg')]: {
      flexDirection: "row",
      alignItems: "center",
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  buttonsGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
    [theme.breakpoints.down('md')]: {
      order: 1,
      justifyContent: "center",
    },
  },
  topButton: {
    minWidth: "auto",
    [theme.breakpoints.down('md')]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.6, 1.2),
      minWidth: "80px",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.5, 1),
      minWidth: "70px",
    },
    [theme.breakpoints.down(480)]: {
      fontSize: "0.7rem",
      padding: theme.spacing(0.4, 0.8),
      minWidth: "60px",
    },
  },
  searchField: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: "300px",
      order: 1,
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      width: "100%",
      order: 2,
      marginTop: theme.spacing(1),
    },
  },
  // Estilos responsivos para paginação
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      '& .MuiPagination-root': {
        '& .MuiPaginationItem-root': {
          fontSize: "0.75rem",
          minWidth: "28px",
          height: "28px",
          margin: "0 1px",
        },
        '& .MuiPaginationItem-icon': {
          fontSize: "1rem",
        },
      },
    },
    [theme.breakpoints.down(480)]: {
      '& .MuiPagination-root': {
        '& .MuiPaginationItem-root': {
          fontSize: "0.7rem",
          minWidth: "24px",
          height: "24px",
          margin: "0 0.5px",
        },
        '& .MuiPaginationItem-icon': {
          fontSize: "0.9rem",
        },
      },
    },
  },
}));

const ContactListItems = () => {
  const classes = useStyles();
  const theme = useTheme();

  const { user, socket } = useContext(AuthContext);
  const { validationProgress: globalValidationProgress, startValidation, updateValidationProgress, finishValidation } = useValidationProgress();

  const { contactListId } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  
  // Reducer para gerenciar atualizações de contatos
  const contactsReducer = (state, action) => {
    switch (action.type) {
      case 'LOAD_CONTACTS':
        // Para paginação, substituímos os contatos em vez de acumular
        return action.payload;
      case 'UPDATE_CONTACTS':
        const contact = action.payload;
        const contactIndex = state.findIndex((c) => c.id === contact.id);
        if (contactIndex !== -1) {
          // Criar um novo array sem mutar o estado original
          const newState = [...state];
          newState[contactIndex] = { ...newState[contactIndex], ...contact };
          return newState;
        } else {
          return [contact, ...state];
        }
      case 'DELETE_CONTACT':
        const contactId = action.payload;
        const index = state.findIndex((c) => c.id === contactId);
        if (index !== -1) {
          state.splice(index, 1);
        }
        return [...state];
      case 'RESET':
        return [];
      default:
        return state;
    }
  };
  
  const [contacts, dispatch] = useReducer(contactsReducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactListItemModalOpen, setContactListItemModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [totalContacts, setTotalContacts] = useState(0);
  const [contactList, setContactList] = useState({});
  const [listInfoLoading, setListInfoLoading] = useState(true);
  const fileUploadRef = useRef(null);
  const [exportStatus, setExportStatus] = useState("");
  const [invalidContactsModalOpen, setInvalidContactsModalOpen] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [validationConfirmationOpen, setValidationConfirmationOpen] = useState(false);
  
  // Estados para controle do progresso de importação
  const [importProgress, setImportProgress] = useState({
    isImporting: false,
    processed: 0,
    total: 0,
    message: "",
    action: ""
  });

  const [importReport, setImportReport] = useState({
    open: false,
    skippedLines: [],
    failedLines: [],
    duplicateLines: [],
    totalContacts: 0,
    importedContacts: 0,
    duplicateContacts: 0
  });

  // Estados para controle do progresso de validação
  const [validationProgress, setValidationProgress] = useState({
    isValidating: false,
    processed: 0,
    total: 0,
    message: ""
  });

  const { findById: findContactList } = useContactLists();

  // Função para buscar contatos
  const fetchContacts = async (reset = false) => {
    try {
      setLoading(true);
      const currentPage = reset ? 1 : pageNumber;
      const { data } = await api.get(`contact-list-items`, {
        params: { searchParam, pageNumber: currentPage, contactListId },
      });
      
      if (reset) {
        dispatch({ type: "RESET" });
        setPageNumber(1);
      }
      
      dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
      setHasMore(data.hasMore);
      setTotalContacts(data.count);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  // Função para buscar contatos sem ativar loading (para não bloquear interface durante validação)
  const fetchContactsWithoutLoading = async (reset = false) => {
    try {
      const currentPage = reset ? 1 : pageNumber;
      const { data } = await api.get(`contact-list-items`, {
        params: { searchParam, pageNumber: currentPage, contactListId },
      });
      
      if (reset) {
        dispatch({ type: "RESET" });
        setPageNumber(1);
      }
      
      dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
      setHasMore(data.hasMore);
      setTotalContacts(data.count);
    } catch (err) {
      toastError(err);
    }
  };

  // Função para lidar com mudança de página
  const handlePageChange = (event, value) => {
    setPageNumber(value);
  };

  // Carrega as informações da lista de contatos
  useEffect(() => {
    setListInfoLoading(true);
    findContactList(contactListId).then((data) => {
      setContactList(data);
      setListInfoLoading(false);
    }).catch(() => {
      setListInfoLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactListId]);

  // Reset ao modificar busca
  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  // Busca os contatos via API
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, contactListId]);

  // Escutar eventos de atualização de contatos durante a validação
  useEffect(() => {
    if (!socket || !user?.companyId || !contactListId) return;

    const handleContactValidated = (data) => {
      if (data.contactListId === contactListId && data.contactId) {
        updateContactValidationStatus(data.contactId, data.isValid);
      }
    };

    socket.on(`company-${user.companyId}-contact-validated`, handleContactValidated);

    return () => {
      socket.off(`company-${user.companyId}-contact-validated`, handleContactValidated);
    };
  }, [socket, user?.companyId, contactListId]);

  // Sincronizar estado local de validação com contexto global
  // Só mostrar progresso se for da lista atual
  useEffect(() => {
    const isCurrentList = !globalValidationProgress.contactListId || 
                         globalValidationProgress.contactListId === parseInt(contactListId);
    
    setValidationProgress({
      isValidating: globalValidationProgress.isValidating && isCurrentList,
      processed: isCurrentList ? globalValidationProgress.processed : 0,
      total: isCurrentList ? globalValidationProgress.total : 0,
      message: (globalValidationProgress.isValidating && isCurrentList) ? "Validando contatos..." : ""
    });
  }, [globalValidationProgress, contactListId]);

  // WebSocket - mantém a lista atualizada
  useEffect(() => {
    const companyId = user.companyId;

    const onCompanyContactLists = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.record });
        // Atualizar contador total quando contatos são adicionados ou atualizados
        fetchContactsWithoutLoading();
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.id });
        // Atualizar contador total quando contatos são removidos
        fetchContactsWithoutLoading();
      }

      if (data.action === "reload") {
        dispatch({ type: "LOAD_CONTACTS", payload: data.records });
        // Atualizar contador total quando contatos são recarregados
        fetchContactsWithoutLoading();
      }
      
      // Atualizar contador de contatos inválidos se fornecido
      if (data.contactList && data.contactList.invalidContactsCount !== undefined) {
        setContactList(prevContactList => ({
          ...prevContactList,
          invalidContactsCount: data.contactList.invalidContactsCount
        }));
      }
    };
    
    // Listener para progresso de importação
    const onImportProgress = (data) => {
      // Só mostrar a modal se for realmente importação (action = 'progress')
      // Durante validação (action = 'validation'), não mostrar a modal
      if (data.action === 'progress') {
        setImportProgress({
          isImporting: true,
          processed: data.processed || 0,
          total: data.total || 0,
          message: data.message || "Processando...",
          action: data.action || "progress"
        });
      }
    };

    // Listener para finalização da importação
    // Array para armazenar timeouts e permitir cleanup
    const timeouts = [];

    const onImportCompleted = (data) => {
      // Mostrar toast de sucesso
      toast.success(i18n.t("contactListItems.toasts.imported"));
      
      // Fechar a modal de progresso imediatamente
      setImportProgress({
        isImporting: false,
        processed: 0,
        total: 0,
        message: "",
        action: "completed"
      });
      
      // Verificar se há dados de relatório para mostrar
      if (data.importReport) {
        setImportReport({
          open: true,
          skippedLines: data.importReport.skippedLines || [],
          failedLines: data.importReport.failedLines || [],
          duplicateLines: data.importReport.duplicateLines || [],
          totalContacts: data.importReport.totalContacts || 0,
          importedContacts: data.importReport.importedContacts || 0,
          duplicateContacts: data.importReport.duplicateContacts || 0,
          isCancelled: false
        });
      }
      
      // Sempre iniciar indicador de validação imediatamente após importação
      // Não depender de data.validationStarted
      setValidationProgress({
        isValidating: true,
        processed: 0,
        total: data.total || 0,
        message: "Validando contatos..."
      });
      
      // Atualizar contexto global
      updateValidationProgress(0, data.total || 0);
      
      // Recarregar contatos após 1 segundo
      const timeoutId = setTimeout(() => {
        fetchContacts(true);
      }, 1000);
      timeouts.push(timeoutId);
    };

    const onImportCancelled = (data) => {
      setImportProgress({
        isImporting: false,
        processed: data.processed || 0,
        total: data.total || 0,
        message: data.message || "Importação cancelada pelo usuário",
        action: "cancelled"
      });
      
      toast.info("Importação cancelada. Contatos já processados foram mantidos.");
      
      // Verificar se há dados de relatório para mostrar (mesmo quando cancelado)
      if (data.importReport) {
        setImportReport({
          open: true,
          skippedLines: data.importReport.skippedLines || [],
          failedLines: data.importReport.failedLines || [],
          duplicateLines: data.importReport.duplicateLines || [],
          totalContacts: data.importReport.totalContacts || 0,
          importedContacts: data.importReport.importedContacts || 0,
          duplicateContacts: data.importReport.duplicateContacts || 0,
          isCancelled: data.action === "cancelled"
        });
      }
      
      // Recarregar contatos após 2 segundos
      const timeoutId = setTimeout(() => {
        fetchContacts(true);
      }, 2000);
      timeouts.push(timeoutId);
    };

    // Listener para progresso de validação
    const onValidationProgress = (data) => {
      // Atualizar estado local para compatibilidade
      setValidationProgress({
        isValidating: true,
        processed: data.processed || 0,
        total: data.total || 0,
        message: data.message || "Validando contatos..."
      });
      
      // Atualizar contexto global
      updateValidationProgress(data.processed || 0, data.total || 0);
      
      // Atualizar contador de contatos inválidos em tempo real
      if (data.invalidContactsCount !== undefined) {
        setContactList(prevContactList => ({
          ...prevContactList,
          invalidContactsCount: data.invalidContactsCount
        }));
      }
    };

    // Listener para finalização da validação
    const onValidationCompleted = (data) => {
      // Atualizar estado local para compatibilidade
      setValidationProgress({
        isValidating: false,
        processed: data.processed || 0,
        total: data.total || 0,
        message: data.message || "Validação concluída!"
      });
      
      // Finalizar validação no contexto global
      finishValidation();
      
      // Atualizar contador final de contatos inválidos imediatamente
      if (data.invalidContactsCount !== undefined) {
        setContactList(prevContactList => ({
          ...prevContactList,
          invalidContactsCount: data.invalidContactsCount
        }));
      } else {
        // Se não recebemos o contador, fazer uma requisição para obter os dados atualizados
        api.get(`/contact-lists/${contactListId}`)
          .then(response => {
            if (response.data) {
              setContactList(prevContactList => ({
                ...prevContactList,
                ...response.data,
                invalidContactsCount: response.data.invalidContactsCount || 0
              }));
            }
          })
          .catch(err => console.error(err));
      }
      
      // Recarregar contatos para mostrar status atualizado sem ativar loading
      const timeoutId = setTimeout(() => {
        fetchContactsWithoutLoading(true);
      }, 1000);
      
      // Cleanup do timeout para evitar memory leak
      return () => clearTimeout(timeoutId);
    };

    socket.on(`company-${companyId}-ContactListItem`, onCompanyContactLists);
    socket.on(`company-${companyId}-import-progress`, onImportProgress);
    socket.on(`company-${companyId}-import-completed`, onImportCompleted);
    socket.on(`company-${companyId}-import-cancelled`, onImportCancelled);
    socket.on(`company-${companyId}-validation-progress`, onValidationProgress);
    socket.on(`company-${companyId}-validation-completed`, onValidationCompleted);
    socket.on(`import-progress-${contactListId}`, onImportProgress);
    socket.on(`import-completed-${contactListId}`, onImportCompleted);
    socket.on(`import-cancelled-${contactListId}`, onImportCancelled);

    return () => {
      // Limpar todos os timeouts
      timeouts.forEach(timeoutId => clearTimeout(timeoutId));
      
      socket.off(`company-${companyId}-ContactListItem`, onCompanyContactLists);
      socket.off(`company-${companyId}-import-progress`, onImportProgress);
      socket.off(`company-${companyId}-import-completed`, onImportCompleted);
      socket.off(`company-${companyId}-import-cancelled`, onImportCancelled);
      socket.off(`company-${companyId}-validation-progress`, onValidationProgress);
      socket.off(`company-${companyId}-validation-completed`, onValidationCompleted);
      socket.off(`import-progress-${contactListId}`, onImportProgress);
      socket.off(`import-completed-${contactListId}`, onImportCompleted);
      socket.off(`import-cancelled-${contactListId}`, onImportCancelled);
    };
  }, [contactListId, socket, user.companyId, fetchContactsWithoutLoading]);

  // Captura do campo de busca
  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  // Abre modal de cadastro/edição
  const handleOpenContactListItemModal = () => {
    setSelectedContactId(null);
    setContactListItemModalOpen(true);
  };

  // Fecha modal de cadastro/edição
  const handleCloseContactListItemModal = () => {
    setSelectedContactId(null);
    setContactListItemModalOpen(false);
  };

  // Fecha modal de relatório de importação
  const handleCloseImportReport = () => {
    setImportReport(prev => ({
      ...prev,
      open: false
    }));
  };

  // Editar contato
  const handleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactListItemModalOpen(true);
  };

  // Deletar contato
  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contact-list-items/${contactId}`);
      toast.success(i18n.t("contactListItems.toasts.deleted"));
    } catch (err) {
      toastError(i18n.t("contactListItems.toasts.errorDelete"));
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  // Importar contatos de XLS / XLSX
  const handleImportContacts = async () => {
    try {
      // Inicializar estado de importação
      setImportProgress({
        isImporting: true,
        processed: 0,
        total: 0,
        message: "Iniciando importação...",
        action: "progress"
      });

      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      
      await api.request({
        url: `contact-lists/${contactListId}/upload`,
        method: "POST",
        data: formData,
      });
      
      // Não recarregar a página - o socket.io vai atualizar os dados
      setConfirmOpen(false);
      setPageNumber(1);
      
    } catch (err) {
      setImportProgress(prev => ({
        ...prev,
        isImporting: false
      }));
      toastError(i18n.t("contactListItems.toasts.errorImport"));
    }
  };

  // Cancelar importação
  const handleCancelImport = async () => {
    try {
      await api.request({
        url: `contact-lists/${contactListId}/cancel-upload`,
        method: "POST",
      });
    } catch (err) {
      toastError("Erro ao cancelar importação");
    }
  };

  // Função para contar contatos inválidos (total de todas as páginas)
  const getInvalidContactsCount = () => {
    return contactList.invalidContactsCount || 0;
  };

  // Função para atualizar contatos em tempo real durante a validação
  const updateContactValidationStatus = (contactId, isValid) => {
    dispatch({
      type: "UPDATE_CONTACTS",
      payload: { id: contactId, isWhatsappValid: isValid }
    });
    
    // Atualizar contador de contatos inválidos em tempo real
    if (isValid) {
      // Se o contato foi validado como válido, decrementar o contador
      setContactList(prevContactList => ({
        ...prevContactList,
        invalidContactsCount: Math.max(0, (prevContactList.invalidContactsCount || 0) - 1)
      }));
    } else {
      // Se o contato foi validado como inválido, incrementar o contador
      setContactList(prevContactList => ({
        ...prevContactList,
        invalidContactsCount: (prevContactList.invalidContactsCount || 0) + 1
      }));
    }
  };

  // Função para abrir modal de contatos inválidos
  const handleOpenInvalidContactsModal = () => {
    setInvalidContactsModalOpen(true);
  };

  // Função para exportar e excluir contatos inválidos
  const handleExportAndDeleteInvalidContacts = async () => {
    try {
      setLoading(true); // Mostrar loading durante o processo
      
      // Buscar TODOS os contatos inválidos da lista usando paginação
      let allInvalidContacts = [];
      let currentPage = 1;
      let hasMore = true;
      
      while (hasMore) {
        const { data } = await api.get(`/contact-list-items`, {
          params: {
            contactListId,
            isWhatsappValid: false,
            pageNumber: currentPage,
            searchParam: "" // Buscar todos, sem filtro de pesquisa
          }
        });
        
        if (data.contacts && data.contacts.length > 0) {
          allInvalidContacts = [...allInvalidContacts, ...data.contacts];
          hasMore = data.hasMore;
          currentPage++;
        } else {
          hasMore = false;
        }
      }
      
      if (allInvalidContacts.length === 0) {
        toast.info("Não há contatos inválidos para exportar.");
        setLoading(false);
        return;
      }

      // Exportar para Excel
      const wb = XLSX.utils.book_new();
      const wsData = [
        ["Nome", "Número"],
        ...allInvalidContacts.map(contact => [contact.name, contact.number])
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, "Contatos Inválidos");
      XLSX.writeFile(wb, "contatos_invalidos.xlsx");

      // Excluir contatos inválidos de uma vez
      const invalidContactIds = allInvalidContacts.map(contact => contact.id);
      await api.post(`/contact-list-items/delete-batch`, {
        ids: invalidContactIds
      });

      // Recarregar a lista
      setPageNumber(1);
      await fetchContacts(true);
      setInvalidContactsModalOpen(false);
      
      toast.success(`${allInvalidContacts.length} contatos inválidos foram exportados e excluídos.`);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false); // Garantir que o loading seja resetado
    }
  };

  // Volta para a página de "Listas de Contatos"
  const goToContactLists = () => {
    history.push("/contact-lists");
  };

  // Função para iniciar validação manual dos contatos
  const handleValidateContacts = async () => {
    if (!contactListId) return;
    
    try {
      // Iniciar validação no contexto global
      startValidation(contactListId);
      toast.success("Validação iniciada!");
      // Chamar API para iniciar validação (processo assíncrono)
      await api.post(`/contact-lists/${contactListId}/validate`);
      // A conclusão será tratada via evento de socket (onValidationCompleted)
    } catch (err) {
      toastError(err);
      // Finalizar validação em caso de erro
      finishValidation();
    }
  };

  // Função para cancelar validação
  const handleCancelValidation = async () => {
    if (!contactListId) return;
    
    try {
      // Chamar API para cancelar validação
      await api.post(`/contact-lists/${contactListId}/cancel-validate`);
      
      toast.success("Validação cancelada com sucesso!");
      // Finalizar validação no contexto global
      finishValidation();
    } catch (err) {
      toastError(err);
    }
  };

  // Função para abrir modal de confirmação de validação
  const handleOpenValidationConfirmation = () => {
    // Verificar se há contatos inválidos na lista
    if (getInvalidContactsCount() === 0) {
      toast.warn("Não há contatos inválidos para validar");
      return;
    }
    
    // Verificar se há conexão ativa (precisamos buscar essa informação)
    // Por enquanto, vamos apenas abrir a modal de confirmação
    setValidationConfirmationOpen(true);
  };

  // Função para verificar se há conexão ativa
  const checkActiveConnection = async () => {
    try {
      const response = await api.get('/whatsapp/');
      const whatsappSessions = response.data;
      
      // Verificar se há pelo menos uma sessão com status 'connected'
      const hasActiveConnection = whatsappSessions.some(
        session => session.status === 'connected' || session.status === 'CONNECTED'
      );
      
      return hasActiveConnection;
    } catch (err) {
      console.error('Erro ao verificar conexões:', err);
      return false;
    }
  };



  // Função para fechar modal de confirmação de validação
  const handleCloseValidationConfirmation = () => {
    setValidationConfirmationOpen(false);
  };

  // Função para confirmar e iniciar validação
  const handleConfirmValidation = async () => {
    handleCloseValidationConfirmation();
    
    // Verificar se há conexão ativa antes de iniciar a validação
    const hasActiveConnection = await checkActiveConnection();
    if (!hasActiveConnection) {
      toast.warn("Não há conexão ativa para iniciar a validação");
      return;
    }
    
    handleValidateContacts();
  };

  // Exportar todos os contatos da lista
  const handleOnExportContacts = async () => {
    setExporting(true);
    setExportStatus(i18n.t("contactListItems.toasts.exporting"));

    try {
      let allContacts = [];
      let currentPage = 1;
      let totalPages = 1;

      // Buscar todas as páginas de contatos
      while (currentPage <= totalPages) {
        setExportStatus(
          `${i18n.t("contactListItems.toasts.exporting")} - Página ${currentPage} de ${totalPages}...`
        );
        const { data } = await api.get(`contact-list-items`, {
          params: { searchParam: "", pageNumber: currentPage, contactListId },
        });

        allContacts = [...allContacts, ...data.contacts];

        const perPage = 20;
        totalPages = Math.ceil(data.count / perPage);
        currentPage += 1;
      }

      setExportStatus(
        `Processando ${allContacts.length} ${i18n.t("contactListItems.toasts.contacts")}...`
      );

      if (allContacts.length === 0) {
        toast.warn(i18n.t("contactListItems.toasts.noContactsToExport"));
        setExporting(false);
        setExportStatus("");
        return;
      }

      // Mapeia contatos para formato de exportação
      const exportData = allContacts.map((e) => ({
        [i18n.t("contactListItems.table.name")]: e.name,
        [i18n.t("contactListItems.table.number")]: e.number,
        [i18n.t("contactListItems.dialog.whatsapp")]: e.whatsapp,
        [i18n.t("contactListItems.table.email")]: e.email,
        Tags: e.tags ? e.tags.map((tag) => tag.name).join(", ") : "",
      }));

      setExportStatus(i18n.t("contactListItems.toasts.generatingExcel"));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(wb, ws, "Contatos da Campanha");

      XLSX.writeFile(wb, "contatos_campanha.xlsx");

      setExportStatus(i18n.t("contactListItems.toasts.exported"));
      toast.success(i18n.t("contactListItems.toasts.exported"));
    } catch (err) {
      toastError(i18n.t("contactListItems.toasts.errorExport"));
      setExportStatus(i18n.t("contactListItems.toasts.errorExport"));
    } finally {
      setExporting(false);
      setTimeout(() => {
        setExportStatus("");
      }, 3000);
    }
  };

  // Aqui exibimos ForbiddenPage se for "user" E "allowCampaigns === disabled"
  return (
    <MainContainer className={classes.mainContainer}>
      <ContactListItemModal
        open={contactListItemModalOpen}
        onClose={handleCloseContactListItemModal}
        onSave={fetchContacts}
        contactId={selectedContactId}
        title={i18n.t("contactListItems.dialog.add")}
      />
      <ConfirmationModal
        title={
          deletingContact
            ? i18n.t("contactListItems.confirmationModal.deleteTitle")
            : i18n.t("contactListItems.confirmationModal.importTitle")
        }
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={() =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : handleImportContacts()
        }
      >
        {deletingContact ? (
          <p>{i18n.t("contactListItems.confirmationModal.deleteMessage")}</p>
        ) : (
          <>
            {i18n.t("contactListItems.confirmationModal.importMessage")}{" "}
            <a href={planilhaExemplo} download="planilha.xlsx">
              {i18n.t("contactListItems.buttons.import")}
            </a>
          </>
        )}
      </ConfirmationModal>

      {user.profile === "user" && user.allowCampaigns === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <>
          <MainHeader>
            <Grid style={{ width: "99.6%" }} container>
              <Grid xs={12} sm={5} item>
                <Box display="flex" alignItems="center">
                  <Title>{i18n.t("contactListItems.title")}</Title>
                  
                  {/* Indicador de validação fora do botão de contatos inválidos */}
                  {validationProgress.isValidating && (
                    <Box display="flex" alignItems="center" style={{ marginLeft: 8, gap: 8 }}>
                      <CircularProgress 
                        size={16} 
                        style={{ color: theme.palette.primary.main }}
                      />
                      <span style={{ color: theme.palette.primary.main, fontSize: '12px' }}>
                        {validationProgress.processed && validationProgress.total 
                          ? `${Math.round((validationProgress.processed / validationProgress.total) * 100)}%`
                          : '0%'
                        }
                      </span>
                      <Button 
                        variant="outlined" 
                        size="small" 
                        onClick={handleCancelValidation}
                        style={{ 
                          color: theme.palette.error.main, 
                          borderColor: theme.palette.error.main,
                          marginLeft: 8,
                          fontSize: '12px',
                          padding: '2px 8px'
                        }}
                      >
                        Cancelar
                      </Button>
                    </Box>
                  )}
                  
                  {/* Botão de contatos inválidos - Ocultar durante validação e quando não houver contatos inválidos */}
                  {(getInvalidContactsCount() > 0 && !validationProgress.isValidating) && (
                    <Box 
                      className={classes.invalidContactsIndicator}
                      onClick={validationProgress.isValidating ? null : handleOpenInvalidContactsModal}
                      style={{ 
                        cursor: validationProgress.isValidating ? 'default' : 'pointer',
                        opacity: validationProgress.isValidating ? 0.7 : 1
                      }}
                    >
                      <span className={classes.invalidContactsCount}>
                        {getInvalidContactsCount()}
                      </span>
                      <span className={classes.invalidContactsText}>
                        Inválido(s)
                      </span>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid xs={12} sm={7} item>
                <Box className={classes.topButtonsContainer}>
                  <TextField
                    placeholder={i18n.t("contactListItems.searchPlaceholder")}
                    type="search"
                    value={searchParam}
                    onChange={handleSearch}
                    className={classes.searchField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: "gray" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box className={classes.buttonsGroup}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={goToContactLists}
                      disabled={globalValidationProgress.isValidating}
                      className={classes.topButton}
                      style={{ 
                        backgroundColor: globalValidationProgress.isValidating ? '#ccc' : '',
                        color: globalValidationProgress.isValidating ? '#666' : ''
                      }}
                    >
                      {i18n.t("contactListItems.buttons.lists")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (!globalValidationProgress.isValidating) {
                          fileUploadRef.current.value = null;
                          fileUploadRef.current.click();
                        }
                      }}
                      disabled={globalValidationProgress.isValidating}
                      className={classes.topButton}
                      style={{ 
                        backgroundColor: globalValidationProgress.isValidating ? '#ccc' : '',
                        color: globalValidationProgress.isValidating ? '#666' : ''
                      }}
                    >
                      {i18n.t("contactListItems.buttons.import")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (!globalValidationProgress.isValidating) {
                          handleOpenContactListItemModal();
                        }
                      }}
                      disabled={globalValidationProgress.isValidating}
                      className={classes.topButton}
                      style={{ 
                        backgroundColor: globalValidationProgress.isValidating ? '#ccc' : '',
                        color: globalValidationProgress.isValidating ? '#666' : ''
                      }}
                    >
                      {i18n.t("contactListItems.buttons.add")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (!globalValidationProgress.isValidating) {
                          handleOnExportContacts();
                        }
                      }}
                      className={`${classes.exportButton} ${classes.topButton}`}
                      disabled={exporting || globalValidationProgress.isValidating}
                      style={{ 
                        backgroundColor: globalValidationProgress.isValidating ? '#ccc' : '',
                        color: globalValidationProgress.isValidating ? '#666' : ''
                      }}
                    >
                      {exporting
                        ? i18n.t("contactListItems.toasts.exporting")
                        : i18n.t("contactListItems.buttons.export")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </MainHeader>

          {exportStatus && (
            <Box className={classes.statusBox}>
              <p>{exportStatus}</p>
            </Box>
          )}

          <Paper
            className={classes.mainPaper}
            variant="outlined"
          >
            <input
              style={{ display: "none" }}
              id="upload"
              name="file"
              type="file"
              accept=".xls,.xlsx"
              onChange={() => {
                setConfirmOpen(true);
              }}
              ref={fileUploadRef}
            />
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ width: "0%" }}>
                    Status
                  </TableCell>
                  <TableCell>
                    {i18n.t("contactListItems.table.name")}
                  </TableCell>
                  <TableCell align="center">
                    {i18n.t("contactListItems.table.number")}
                  </TableCell>
                  <TableCell align="center">
                    {i18n.t("contactListItems.table.email")}
                  </TableCell>
                  <TableCell align="center">
                    {i18n.t("contactListItems.table.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contacts.map((contact) => (
                  <TableRow key={contact.id}>
                    <TableCell align="center" style={{ width: "0%" }}>
                      <IconButton>
                        {contact.isWhatsappValid ? (
                          <CheckCircleIcon
                            titleAccess={`${i18n.t(
                              "contactListItems.dialog.whatsapp"
                            )} ${i18n.t("contactListItems.toasts.valid")}`}
                            htmlColor="green"
                          />
                        ) : (
                          <BlockIcon
                            titleAccess={`${i18n.t(
                              "contactListItems.dialog.whatsapp"
                            )} ${i18n.t("contactListItems.toasts.invalid")}`}
                            htmlColor="red"
                          />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>{contact.name}</TableCell>
                    <TableCell align="center">{contact.number}</TableCell>
                    <TableCell align="center">{contact.email}</TableCell>
                    <TableCell align="center">

                      <IconButton
                        size="small"
                        onClick={() => {
                          if (!globalValidationProgress.isValidating) {
                            handleEditContact(contact.id);
                          }
                        }}
                        disabled={globalValidationProgress.isValidating}
                        style={{ 
                          opacity: globalValidationProgress.isValidating ? 0.5 : 1,
                          cursor: globalValidationProgress.isValidating ? 'default' : 'pointer'
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      {(user.profile === "admin" ||
                        user.allowCampaigns === "enabled") && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            if (!globalValidationProgress.isValidating) {
                              setConfirmOpen(true);
                              setDeletingContact(contact);
                            }
                          }}
                          disabled={globalValidationProgress.isValidating}
                          style={{ 
                            opacity: globalValidationProgress.isValidating ? 0.5 : 1,
                            cursor: globalValidationProgress.isValidating ? 'default' : 'pointer'
                          }}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>

          {/* Controles de Paginação */}
          {totalContacts > 0 && (
            <Box className={classes.paginationContainer}>
              <Pagination
                count={Math.ceil(totalContacts / 20)}
                page={pageNumber}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </Box>
          )}
        </>
      )}

      {/* Modal de Contatos Inválidos */}
      <Dialog
        open={invalidContactsModalOpen}
        onClose={() => !loading && setInvalidContactsModalOpen(false)}
        aria-labelledby="invalid-contacts-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="invalid-contacts-dialog-title">
          Contatos Inválidos
          {loading && (
            <Box display="flex" alignItems="center" style={{ marginLeft: 8, gap: 8, float: 'right' }}>
              <CircularProgress 
                size={16} 
                style={{ color: theme.palette.primary.main }}
              />
              <span style={{ color: theme.palette.primary.main, fontSize: '12px' }}>
                Exportando e excluindo
              </span>
            </Box>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Você possui {getInvalidContactsCount()} contatos inválidos nesta lista. 
            Deseja exportar estes contatos para um arquivo Excel e removê-los da lista?
          </DialogContentText>
          <DialogContentText style={{ marginTop: 16, fontWeight: 'bold' }}>
            Esta ação não pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setInvalidContactsModalOpen(false)} 
            color="primary"
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleExportAndDeleteInvalidContacts} 
            color="secondary"
            variant="contained"
            disabled={loading}
          >
            Exportar e Excluir
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Progresso de Importação */}
      <ImportProgressModal
        open={importProgress.isImporting}
        processed={importProgress.processed}
        total={importProgress.total}
        message={importProgress.message}
        action={importProgress.action}
        onCancel={handleCancelImport}
      />

      {/* Modal de Confirmação de Validação */}
      <Dialog
        open={validationConfirmationOpen}
        onClose={handleCloseValidationConfirmation}
        aria-labelledby="validation-confirmation-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="validation-confirmation-dialog-title">
          Confirmar Validação
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            A validação irá processar apenas os contatos inválidos desta lista.
            Durante o processo, mudanças na lista ficarão temporariamente bloqueadas. Deseja iniciar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleCloseValidationConfirmation} 
            color="primary"
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleConfirmValidation} 
            color="secondary"
            variant="contained"
          >
            Iniciar Validação
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Relatório de Importação */}
      <ImportReportModal
        open={importReport.open}
        onClose={handleCloseImportReport}
        skippedLines={importReport.skippedLines}
        failedLines={importReport.failedLines}
        duplicateLines={importReport.duplicateLines}
        totalContacts={importReport.totalContacts}
        importedContacts={importReport.importedContacts}
        duplicateContacts={importReport.duplicateContacts}
        isCancelled={importReport.isCancelled}
      />
    </MainContainer>
  );
};

export default ContactListItems;